export enum RESUME_ACTIONS {
  VIEW,
  DELETE,
  DOWNLOAD,
  DELETE_OTHERS,
}
